import { Box, Typography } from "@mui/material";

import { AppointmentResponse } from "@/api";
import { ClientLink } from "@/common/components/client-link/ClientLink";
import { EllipsisText } from "@/common/components/ellipsis-text/EllipsisText";
import { RowActionButton } from "@/common/components/row-action-button/RowActionButton";
import { useAppointmentLabels } from "@/common/hooks/useAppointmentLabels";

interface Props {
  appointment: AppointmentResponse;
  onOpen: () => void;
}

export function AppointmentRow({ appointment, onOpen }: Props) {
  const { purposeLabelOf } = useAppointmentLabels();
  const clientName = appointment.clientFirstName
    ? `${appointment.clientFirstName} ${appointment.clientLastName ?? ""}`.trim()
    : null;

  return (
    <Box
      display="grid"
      gridTemplateColumns="minmax(0, 1fr) max-content 30px"
      gap={4}
      alignItems="center"
      py={1}
      maxWidth="100%"
    >
      <RowActionButton onClick={onOpen}>
        <EllipsisText value={purposeLabelOf(appointment.purposeKey)} variant="body2" />
      </RowActionButton>

      <Box textAlign={"right"} whiteSpace={"nowrap"}>
        {appointment.clientId && clientName ? (
          <ClientLink clientId={appointment.clientId} name={clientName} variant="body2" />
        ) : (
          <Typography variant="body2" aria-hidden={!clientName}>
            {clientName ?? "-"}
          </Typography>
        )}
      </Box>

      <Typography variant="body2" textAlign={"right"}>
        {appointment.assignedCounselorUserCode}
      </Typography>
    </Box>
  );
}
